import styled from "styled-components"

export const ErrorMessage = styled.div`
  width: 100%;
  margin-top: .25rem;
  font-size: 100%;
  color: #dc3545;
`
